var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeaderShapes = function SvgHeaderShapes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 925,
    height: 320,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#169B62",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.423 119.789c-131.798 0-238.642 106.844-238.642 238.642h238.642zM716.064 358.432c132.432 0 239.79-106.844 239.789-238.642H716.064z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.213 119.789H477.424l239.789 238.642zM1.285 120.937h239.789L1.284-118.853z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 716.5,
    cy: -119.5,
    r: 239.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.182,
    cy: 240.258,
    rx: 119.895,
    ry: 119.321
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.781-118.853h238.642v239.789H238.781z"
  }))));
};
export { SvgHeaderShapes as ReactComponent };
export default __webpack_public_path__ + "images/header-shapes.svg";